import React from 'react'
import Eula from '../eula'

const EulaPl = () => {
    return <Eula languageCode="pl" />
}

export default EulaPl
